'use strict';

import React from 'react';

import personStore from 'stores/PersonStore';
import ConditionalDisplay from 'components/utils/ConditionalDisplay';
import StatusBar from  'components/base/StatusBar';

import utils from 'services/utils';
import _ from 'underscore';
import appConstants from 'constants/appConstants';
import classNames from 'classnames';
import moment from 'moment';


class LeaveApplyEntitlements extends React.Component {
    constructor(props) {
        super(props);
        // this.handleUnitClick = this.handleUnitClick.bind(this);
        this.calculateDays = this.calculateDays.bind(this);
        
        // this.state = {
        //     showInDays: false,
        // };
    }

    // handleUnitClick() {
    //     this.setState({showInDays: !this.state.showInDays});
    // }

    calculateDays(hours, hoursPerDay) {
        return hoursPerDay === 0 ? 0 :
            (hours ? hours / hoursPerDay : 0.00);
    }

    render() {
        let hourDifference = 0;
        let daysDifference = 0;
        let startDate = "";
        let endDate = "";

        let forecastContent = null;

        if (this.props.leaveEntitlements) {
            if (this.props.leaveEntitlements.loading) {
                forecastContent = (
                    <div className="le-extra-table">
                        <div className="row loading-msg">
                            Checking balance...
                        </div>
                    </div>
                );
            } else {
                if (this.props.leaveEntitlements.leaveEntitlements && this.props.leaveEntitlements.leaveEntitlements[0]) {
                    hourDifference = this.props.leaveEntitlements.leaveEntitlements[0].BalanceHours;
                    daysDifference = this.calculateDays(hourDifference, this.props.leaveEntitlements.leaveEntitlements[0].HoursPerDay);
                    startDate = this.props.leaveEntitlements.leaveEntitlements[0].StartDate;
                    endDate = this.props.leaveEntitlements.leaveEntitlements[0].EndDate;

                    if (this.props.needToRecalculateBalance) {
                        forecastContent = (
                            <div>
                                <button
                                    type="button"
                                    className="button--primary button--wide"
                                    onClick={this.props.onCalculateBalanceClick}
                                    disabled={this.props.workDaysAndHoursLoading}
                                >
                                    Check balance
                                </button>
                            </div>
                        );
                    } else if (this.props.leaveEntitlements.leaveEntitlements) {
                        forecastContent = (
                            <div>
                                <div className="le-extra-table">
                                    <div className="row">
                                        <span className="footnote">Leave balance after end date</span> {utils.formatNumber(hourDifference)} hrs ({utils.formatNumber(daysDifference)} days)
                                    </div>
                                </div>
                            </div>
                        );
                    }
                }
            }
        }

        const canContinueString = "You can still continue to apply.";
        const cannotContinueString = "You cannot continue with this application unless you apply for a shorter period of leave or change your future leave.";

        let insufficientBalanceMessageTitle = "There is not enough leave for this application";
        let insufficientBalanceMessageContent = "";
        
        if (this.props.canContinue) {
            insufficientBalanceMessageContent = canContinueString;
        } else {
            insufficientBalanceMessageContent = cannotContinueString;
        }

        if (this.props.leaveEntitlements && !this.props.leaveEntitlements.loading && this.props.leaveEntitlements.leaveEntitlements && !this.props.leaveEntitlements.leaveEntitlements[0].IsValid && this.props.leaveEntitlements.leaveEntitlements.length > 1) {
            const futureLeaveTotalHours = this.props.leaveEntitlements.leaveEntitlements[1].LeaveTotalHours;
            const futureLeaveTotalDays = this.calculateDays(futureLeaveTotalHours, this.props.leaveEntitlements.leaveEntitlements[1].HoursPerDay);
            const futureLeaveHourDifference = this.props.leaveEntitlements.leaveEntitlements[1].BalanceHours;
            const futureLeaveDaysDifference = this.calculateDays(futureLeaveHourDifference, this.props.leaveEntitlements.leaveEntitlements[1].HoursPerDay) * -1;
            const futureLeaveStartDate = this.props.leaveEntitlements.leaveEntitlements[1].StartDate;
            const futureLeaveEndDate = this.props.leaveEntitlements.leaveEntitlements[1].EndDate;
            const futureLeaveReason = this.props.leaveEntitlements.leaveEntitlements[1].LeaveReason;

            insufficientBalanceMessageTitle = "There is not enough leave to cover the following future leave application:";
            insufficientBalanceMessageContent = (
                <div>
                    <p>
                        <span className="font-weight--semi-bold">{"{0} - {1}".format(utils.formatDate(futureLeaveStartDate), utils.formatDate(futureLeaveEndDate))}</span><br />
                        <span>{"Reason: {0}".format(futureLeaveReason)}</span><br />
                        <span>{"Leave Hours: {0} ({1} day)".format(utils.formatNumber(futureLeaveTotalHours),utils.formatNumber(futureLeaveTotalDays))}</span>
                    </p>
                    <p>
                        <span className="font-weight--semi-bold">{"Leave Balance after {0}".format(utils.formatDate(futureLeaveEndDate))}</span><br />
                        <span>{"{0} hrs ({1} day)".format(utils.formatNumber(futureLeaveHourDifference),utils.formatNumber(futureLeaveDaysDifference))}</span>
                    </p>
                    {this.props.canContinue ? (
                        <div>{canContinueString}</div>
                    ) : (
                        <div>{cannotContinueString}</div>
                    )}
                </div>
            );
        }

        return (
            <ConditionalDisplay test={this.props.selectedLeaveReason !== null && this.props.selectedLeaveReason.LeaveType.Name !== 'OtherLeave' && !this.props.forecastingError} className="balance-overview-container">
                {this.props.selectedLeaveReason &&
                    this.props.selectedLeaveReason.LeaveType.IsDisplayBalance ? (
                        <div className="balance-overview">
                            <i className={this.props.selectedLeaveReason ? this.props.selectedLeaveReason.LeaveType.IconName : ""} style={{color: this.props.selectedLeaveReason ? this.props.selectedLeaveReason.LeaveType.ColorName : ""}} />
                            <div className="boc-header-container">
                                <div className="boc-header">
                                    {this.props.selectedLeaveReason ? this.props.selectedLeaveReason.LeaveType.Label : null} Entitlement
                                </div>
                                <div>Balance Forecast</div>
                            </div>

                            {forecastContent}

                        </div>
                    ) : null}

                <ConditionalDisplay test={!this.props.needToRecalculateBalance && (this.props.leaveEntitlements && !this.props.leaveEntitlements.loading) && this.props.isInsufficientBalance &&
                    this.props.selectedLeaveReason && this.props.selectedLeaveReason.LeaveType.IsDisplayBalance}
                >
                    <StatusBar
                        title={insufficientBalanceMessageTitle}
                        content={insufficientBalanceMessageContent}
                        warning={this.props.canContinue}
                        error={!this.props.canContinue}
                    />
                </ConditionalDisplay>

            </ConditionalDisplay>
        );
    }
}


export default LeaveApplyEntitlements; 
